import { get } from 'lodash-es'

import { mapGetters, mapActions } from 'vuex'

import { types as MODULES } from '@/js/plugins/store/store-modules'
import BRANDS_GETTERS from '@/js/plugins/store/modules/brands/getter-types'
import BRANDS_ACTIONS from '@/js/plugins/store/modules/brands/actions-types'
import BRANDS_CONSTANTS from '@/js/plugins/store/modules/brands/brands-constants'
import {
  CLIENT_TO_COMPANY_CODE,
  COMPANY_CODE_TO_BRAND,
} from '@/js/helper/dp-usermanagement-constants.js'
export default {
  beforeMount() {
    if (!this.logoData && this.logoBrand) {
      this.loadLogoData(this.logoBrand)
    }
  },
  watch: {
    logoBrand() {
      this.loadLogoData(this.logoBrand)
    },
  },
  computed: {
    ...mapGetters(MODULES.BRANDS, {
      getLogoData: BRANDS_GETTERS.LOGO_DATA,
      getBrandInfo: BRANDS_GETTERS.BRAND,
    }),
    logoBrand() {
      return this.brand
        ? this.brand
        : this.client
        ? COMPANY_CODE_TO_BRAND?.[CLIENT_TO_COMPANY_CODE?.[this.client]]
        : undefined
    },
    logoData() {
      return this.getLogoData(this.logoBrand)
    },
    brandInfo() {
      return this.getBrandInfo(this.logoBrand)
    },
    viewBox() {
      return get(this.brandInfo, BRANDS_CONSTANTS.LOGO_VIEWBOX)
    },
    viewBoxParts() {
      return this.viewBox ? this.viewBox.split(' ') : []
    },
  },
  methods: {
    ...mapActions(MODULES.BRANDS, {
      loadLogoData: BRANDS_ACTIONS.LOAD_BRAND_LOGO,
    }),
  },
}
